import { call, put, takeLatest } from "redux-saga/effects"
import * as api from "./api"
import { GET_ADMINS, GET_ADMIN_INFO, GET_ADMINS_ERROR } from "./actionTypes"
import { apiError, getAdminsSuccess, getAdminInfoSuccess } from "./actions"
function* loadAdmins({ filters, options }) {
  try {
    const { data } = yield call(api.getAdmins, filters, options)
    yield put(getAdminsSuccess(data))
  } catch (error) { yield put({ type: GET_ADMINS_ERROR }) }
}
function* loadAdminInfo({ id }) {
  try {
    const { data } = yield call(api.getAdminInfo, id)
    yield put(getAdminInfoSuccess(data))
  } catch (error) { yield put(apiError("Could not load this admin. Please try again.")) }
}
export default function* adminsSaga() {
  yield takeLatest(GET_ADMINS, loadAdmins)
  yield takeLatest(GET_ADMIN_INFO, loadAdminInfo)
}
